<template>
    <div v-if="adapter" class="adapter-page">
        <BreadCrumb class="text-white"></BreadCrumb>
        <div class="container-wrapper-evo page">
            <div class="container container-hero">
                <h1 class="section-title">{{ adapter.headings.h1[0] }}</h1>
                <h2 class="section-subtitle">
                    {{ adapter.headings.h2[0] }}
                </h2>
                <a
                    v-if="isMobile && tagEvo && $appConfig.ENABLE_CAMPAIGNS"
                    class="sale-tag-container"
                    :href="tagEvoUrl"
                    :data-is-clickable="tagEvoUrl ? true : false"
                    target="_self"
                >
                    <SaleTag :text="tagEvo" />
                </a>
                <img
                    :src="evoScanner.url"
                    :alt="evoScanner.alt"
                    :title="evoScanner.title"
                    loading="lazy"
                />
                <div class="container-hero__text">
                    <a
                        v-if="
                            !isMobile && tagEvo && $appConfig.ENABLE_CAMPAIGNS
                        "
                        class="sale-tag-container-desktop"
                        :href="tagEvoUrl"
                        :data-is-clickable="tagEvoUrl ? true : false"
                        target="_self"
                    >
                        <SaleTag :text="tagEvo" />
                    </a>
                    <p>
                        {{ t('page-adapter_adapter-description-1') }}
                    </p>
                    <p>
                        {{ t('page-adapter_adapter-description-2') }}
                    </p>
                    <p v-if="isInUK && $appConfig.saleEnabled">
                        {{
                            t(
                                'Order NOW for FREE Carista App Diagnostics. Lifetime access is included. Terms apply.'
                            )
                        }}
                    </p>
                    <div class="price-container">
                        <span class="price"
                            >{{ prices?.currency
                            }}{{
                                campaignPriceEvo && $appConfig.ENABLE_CAMPAIGNS
                                    ? campaignPriceEvo
                                    : prices?.evoAdapterPrice
                            }}</span
                        >
                        <s
                            v-if="
                                campaignPriceEvo && $appConfig.ENABLE_CAMPAIGNS
                            "
                            id="original-price"
                            >{{ prices.currency + prices?.evoAdapterPrice }}</s
                        >
                    </div>
                    <div v-if="isInUK || isInUS" class="feature-label">
                        <ShippingFastTruckIcon />
                        <span>{{ t('shared_free-shipping') }}</span>
                    </div>
                    <button
                        @click="openVendorModal('evo')"
                        class="btn-feedback-outlined lighter"
                    >
                        {{ t('page-adapter_buy-now') }} <ArrowRightIcon />
                    </button>
                </div>
            </div>
        </div>
        <div v-if="showWhiteAdapterSection" class="container-wrapper page">
            <div class="container container-hero">
                <h2 class="section-title">{{ adapter.headings.h2[1] }}</h2>
                <h2 class="section-subtitle">
                    {{ adapter.headings.h2[2] }}
                </h2>
                <a
                    v-if="isMobile && tagObd && $appConfig.ENABLE_CAMPAIGNS"
                    class="sale-tag-container"
                    :href="tagObdUrl"
                    :data-is-clickable="tagObdUrl ? true : false"
                    target="_self"
                >
                    <SaleTag :text="tagObd" />
                </a>
                <img
                    :src="obdScanner.url"
                    :alt="obdScanner.alt"
                    :title="obdScanner.title"
                    loading="lazy"
                />
                <div class="container-hero__text">
                    <a
                        v-if="
                            !isMobile && tagObd && $appConfig.ENABLE_CAMPAIGNS
                        "
                        class="sale-tag-container-desktop"
                        :href="tagObdUrl"
                        :data-is-clickable="tagObdUrl ? true : false"
                        target="_self"
                    >
                        <SaleTag :text="tagObd" />
                    </a>
                    <p>
                        {{ t('page-adapter_adapter-description-3') }}
                    </p>
                    <div class="price-container obd">
                        <span class="price"
                            >{{ prices?.currency
                            }}{{
                                campaignPriceObd && $appConfig.ENABLE_CAMPAIGNS
                                    ? campaignPriceObd
                                    : prices?.adapterPrice
                            }}</span
                        >
                        <s
                            v-if="
                                campaignPriceObd && $appConfig.ENABLE_CAMPAIGNS
                            "
                            id="original-price"
                            >{{ prices.currency + prices?.adapterPrice }}</s
                        >
                    </div>
                    <div v-if="isInUK || isInUS" class="feature-label obd">
                        <ShippingFastTruckIcon :color="'#1B1E21'" />
                        <span>{{ t('shared_free-shipping') }}</span>
                    </div>
                    <button
                        @click="openVendorModal('obd')"
                        class="btn-feedback-outlined lighter"
                    >
                        {{ t('page-adapter_buy-now') }} <ArrowRightIcon />
                    </button>
                </div>
            </div>
        </div>
        <SupportedBrands />
        <HowItWorks
            id="howItWorksSection"
            :content="howItWorksContent"
            :active="active"
            :activeStep="activeStep"
            @changeActiveStep="changeActiveStep"
        />
        <AppPricing id="bottomSection" />
        <FeatureHighlights />
        <UserRatings />
        <VueperSlider
            :title="adapter?.headings?.h4[0]"
            :testimonials="adapterTestimonials"
            :active="6"
            :static="1"
        />
        <Faq
            :active="7"
            :static="true"
            :faqList="adapterFaq"
            :title="adapter?.headings?.h4[1]"
        />
        <PromoSection fbEventParam="adapter page" />
    </div>
</template>

<script setup>
import {
    computed,
    ref,
    onMounted,
    onBeforeMount,
    onBeforeUnmount,
    watch,
} from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import SupportedBrands from '../components/adapter/SupportedBrands';
import BreadCrumb from '../components/breadcrumb/BreadCrumb';
import HowItWorks from '../components/HowItWorks';
import AppPricing from '../components/adapter/AppPricing';
import VueperSlider from '../components/VueperSlider';
import Faq from '../components/Faq';
import ArrowRightIcon from '../assets/icons/supportedCars/ArrowRightIcon';
import {
    createMetaInfo,
    facebookGoogleAnalitycs,
    isValidUrl,
    mapLangFullNameToCode,
    findByTag,
} from '@/utils/helpers';
import { useTranslation } from 'i18next-vue';
import { useHead } from '@unhead/vue';
import SaleTag from '@/components/SaleTag.vue';
import FeatureHighlights from '../components/FeatureHighlights.vue';
import UserRatings from '../components/UserRatings.vue';
import {
    TESTIMONIALS_CATEGORY_ID,
    FAQ_CATEGORY_ID,
    OBD_PHASEOUT_EXPERIMENT_COUNTRIES,
} from '@/utils/constants';
import PromoSection from '@/components/PromoSection.vue';
import ShippingFastTruckIcon from '@/assets/icons/ShippingFastTruckIcon.vue';
import appConfig from '@/config/app.config';
import { useScrollAnimation } from '@/composables/useScrollAnimation';

const { t } = useTranslation(['shared', 'page-adapter']);
const store = useStore();
const { active, activeStep } = useScrollAnimation();

const isMobile = computed(() => store.state.device.isMobile);

const obdScanner = computed(() => {
    const image = findByTag(adapter.value?.images, 'carista-obd2-scanner');

    return {
        url: image?.url,
        alt: image?.imageMeta?.metaAltDescription,
        title: image?.imageMeta?.metaTitle,
    };
});

const evoScanner = computed(() => {
    const image = findByTag(adapter.value?.images, 'carista-evo-scanner');

    return {
        url: image?.url,
        alt: image?.imageMeta?.metaAltDescription,
        title: image?.imageMeta?.metaTitle,
    };
});

const adapter = computed(() => store.state.pages?.adapter);
const prices = computed(() => store.state.prices?.prices);
const howItWorksContent = computed(() =>
    adapter.value.items?.find((item) => item.tag == 'how-it-works' || {})
);
const adapterFaqCategory = FAQ_CATEGORY_ID.ADAPTERS_PAGE;
const adapterFaq = computed(() => store.state.faq?.faq[adapterFaqCategory - 1]);
const faqLinkedData = computed(
    () => store.state.faq.linkedData[adapterFaqCategory - 1]
);
const adapterTestimonials = computed(
    () =>
        store.state.testimonials?.testimonials[
            TESTIMONIALS_CATEGORY_ID.ADAPTERS_PAGE - 1
        ]
);
const langCode = computed(() => store.state.language.lang?.code);
const isInUK = computed(() => store.state.prices?.prices?.countryCode === 'GB');
const isInUS = computed(() => store.state.prices?.prices?.countryCode === 'US');
const tagEvo = computed(() => store.state.campaign?.tags?.adaptersPageEvo);
const tagObd = computed(() => store.state.campaign?.tags?.adaptersPageObd);
const tagEvoUrl = computed(() => {
    const url = store.state.campaign?.tags?.adaptersPageEvoUrl;
    return isValidUrl(url) ? url : null;
});
const tagObdUrl = computed(() => {
    const url = store.state.campaign?.tags?.adaptersPageObdUrl;
    return isValidUrl(url) ? url : null;
});
const campaignPriceEvo = computed(() => store.state.campaign?.prices?.evo);
const campaignPriceObd = computed(() => store.state.campaign?.prices?.obd);

const isFromTargetCountries = computed(() => {
    const countryCode = store.state.geoIP?.geoIP?.countryCode;

    return OBD_PHASEOUT_EXPERIMENT_COUNTRIES.includes(countryCode);
});

const showWhiteAdapterSection = computed(
    () =>
        !(
            appConfig.OBD_PHASEOUT_EXPERIMENT_ENABLED &&
            isFromTargetCountries.value
        )
);

const changeActiveStep = ($event) => {
    activeStep.value = $event;
};

const emitAnalyticsEvent = (eventName, siteUrl, siteName, isEvo, position) => {
    facebookGoogleAnalitycs(eventName, {
        siteName,
        siteUrl,
        button_position: position,
        adapterName: isEvo ? 'EVO' : 'OBD',
    });
};

const openVendorModal = (adapterType) => {
    const siteUrl =
        adapterType === 'evo'
            ? prices.value.vendors[0]?.evoSiteUrl
            : prices.value.vendors[0]?.siteUrl;
    const isEvo = adapterType === 'evo';

    if (prices?.value.vendors.length <= 1) {
        facebookGoogleAnalitycs('buy_now', {
            siteName: prices.value.vendors[0]?.siteName,
            siteUrl: siteUrl,
            adapterName: isEvo ? 'EVO' : 'OBD',
        });

        const shouldOpenNewTab = !/shop.+carista.com|2ly.link./.test(siteUrl);
        window.open(siteUrl, shouldOpenNewTab ? '_blank' : '_self');
    } else {
        facebookGoogleAnalitycs('buy_now', {
            siteName: prices.value.vendors[0]?.siteName,
            siteUrl: siteUrl,
            adapterName: isEvo ? 'EVO' : 'OBD',
        });
        store.dispatch('modals/openModal', {
            currentModal: 'isVendorModalOpen',
            data: adapterType || true,
        });
    }
};

const headControl = useHead(() => {
    return createMetaInfo({
        title: adapter.value?.metaTitle,
        pageMeta: adapter.value,
    });
});

onBeforeMount(async () => {
    if (!store.state.pages.adapter) {
        store.dispatch('pages/getPageByTag', { tag: 'adapter' });
    }

    if (!store.state.pages.pricing) {
        await store.dispatch('pages/getPageByTag', { tag: 'pricing' });
    }

    if (!store.state.pages.app) {
        store.dispatch('pages/getPageByTag', { tag: 'app' });
    }

    if (
        !adapterTestimonials.value ||
        (adapterTestimonials.value &&
            mapLangFullNameToCode(adapterTestimonials?.value[0].language) !==
                langCode.value)
    ) {
        await store.dispatch('testimonials/getTestimonials', {
            lang: langCode.value,
            categoryId: TESTIMONIALS_CATEGORY_ID.ADAPTERS_PAGE,
        });
    }

    if (
        !adapterFaq.value ||
        (adapterFaq.value &&
            mapLangFullNameToCode(adapterFaq?.value[0].language) !==
                langCode.value)
    ) {
        await store.dispatch('faq/getFaq', {
            lang: langCode.value,
            categoryId: adapterFaqCategory,
        });
    }
});

onMounted(() => {
    document.body.classList.remove('overflow-hidden');
    store.dispatch('vehiclebrands/getBrands');
});

watch(langCode, (newVal) => {
    store.dispatch('testimonials/getTestimonials', {
        lang: newVal,
        categoryId: TESTIMONIALS_CATEGORY_ID.ADAPTERS_PAGE,
    });
    store.dispatch('faq/getFaq', {
        lang: newVal,
        categoryId: adapterFaqCategory,
    });
});

watch(faqLinkedData, () => {
    const baseMetaInfo = createMetaInfo({
        title: adapter.value?.metaTitle,
        pageMeta: adapter.value,
    });

    const headConfig = {
        ...baseMetaInfo,
        script: [
            {
                key: 'faq-structured-data',
                type: 'application/ld+json',
                textContent: faqLinkedData.value,
            },
        ],
    };

    headControl.patch({
        ...headConfig,
    });
});
</script>

<style lang="scss" scoped>
.container-hero__text {
    @media (max-width: $screen-md) {
        .btn-feedback-outlined {
            grid-row: 2;
        }
        &:has(.feature-label) {
            .btn-feedback-outlined {
                grid-row: 3;
            }
        }
    }
}

.price-container {
    color: $color-white;
    font-size: 32px;
    font-weight: 500;
    margin: 20px 0 24px;

    display: flex;
    align-items: center;
    gap: 20px;

    &.obd {
        color: $color-black;
    }

    #original-price {
        font-size: 24px;
        color: $color-neutral-dark;
    }

    @media (max-width: $screen-md) {
        justify-content: center;
        text-align: center;
        margin: 0 0 50px 0;
        grid-row: 1;

        &:has(~ .feature-label) {
            margin-bottom: 12px;
        }
    }
}

.feature-label {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 42px;
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 600;
    color: $color-light;

    &.obd {
        color: $color-neutral-deep;
    }

    @media (max-width: $screen-md) {
        grid-row: 2;
        justify-content: center;
    }
}

#original-price {
    font-size: 24px;
    color: $color-neutral-dark;
}

.sale-tag-container {
    margin: 0px auto;
}

.sale-tag-container-desktop {
    margin-bottom: 2.6rem;
}
</style>
